const config = {
  // baseURL: "http://localhost:3000",
  baseURL: "https://school-map-1.herokuapp.com",
  key: "AIzaSyAkumUtBwCSMmdE2eP3zFQfl2t384x7vI8",
};

export default config;
